import { useEffect, useState } from 'react'
import { ImageProps, Image } from 'react-bootstrap'


export default function ImageWithFallback({ src, ...props }: ImageProps) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src)
  const onError = () => setImgSrc("img/placeholder.jpg")

  useEffect(() => {
    setImgSrc(src);
  }, [src])

  return <Image src={imgSrc} onError={onError} {...props} />
}